import React from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Section from '../../../components/ui/Section';
import infoList from './infoList.js';
import amrsaadAvatarUrl from '../../../images/about/about/amrsaad-avatar.jpg';

function AboutSection() {
	return (
		<Section className='bg bg-light-trans md:bg-transparent md:pb-0'>
			<div className='md:bg-gray-100 md:shadow md:rounded-2xl md:p-10 md:border md:border-solid md:border-gray-200'>
				<div className=' flex flex-col sm:flex-row justify-center items-center space-y-5  sm:space-y-0 sm:space-x-10 text-center sm:text-left  w-fit mx-auto'>
					<img
						className='w-40  h-40 object-cover rounded-3xl shadow-xl  p-1 bg-gray-50 border-2 border-solid border-gray-400'
						src={amrsaadAvatarUrl}
						alt='amr saad Avatar'
					/>
					<div>
						<Typography variant='h5' gutterBottom component='h2'>
							<span className='block my-1 text-2xl sm:text-3xl uppercase font-normal tracking-wider'>
								Amr Saad Abdallah
							</span>
							<span className='text-base sm:text-lg text-primary-dark font-normal uppercase tracking-wider'>
								Frontend Developer
							</span>
						</Typography>
					</div>
				</div>

				<ul className='mt-5 sm:mt-10 mb-5'>
					{infoList.map((item, index) => (
						<li key={index} className='mt-4'>
							{item}
						</li>
					))}
				</ul>

				<Button
					variant='contained'
					size='large'
					endIcon='&rarr;'
					href='https://github.com/amrsaadabdallah/resume'
					target='_blank'
				>
					more deatils
				</Button>
			</div>
		</Section>
	);
}

export default AboutSection;
